import { useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { useLocation } from '@reach/router';
import { parse } from 'query-string';
import { Spinner } from 'components/spinner/Spinner';
import PaidImage from '../../images/Paid_Stamp.jpg';
import Logo from '../../images/Logo.png';

const InvoicePage = (props: RouteComponentProps) => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [generalErrors, setGeneralErrors] = useState<string[]>([]);

  const location = useLocation();
  const searchParams = parse(location.search);

  const { invoice_id, token } = searchParams;

  return (
    <>
      {/* {loading && <Spinner />}
      {data && ( */}
      <>
        <form>
          <div className="InvoiceContainer">
            <div className="PageContentBox">
              <div className="HeaderContainer">
                <div className="LeftSide">
                  <h1>INVOICE</h1>
                  <div className="SubTitle">Get Set 4 Education</div>
                  <div className="Info">
                    <span>Invoice date:</span> 20 Mar 2020
                  </div>
                  <div className="Info">
                    <span>Invoice number:</span> INV-0047
                  </div>
                  <img src={PaidImage} alt="Paid" />
                </div>

                <div className="RightSide">
                  <img src={Logo} alt="Get Set 4 Education Logo" />
                </div>
              </div>

              <div className="SummaryContainer">
                <div className="TableContainer">
                  <table>
                    <thead>
                      <tr>
                        <th className="Left">Description</th>
                        <th className="Middle">Price</th>
                        <th className="Middle">VAT(20%)</th>
                        <th className="Right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="Left">Get Set 4 PE</td>
                        <td className="Middle">£370.00</td>
                        <td className="Middle">£74.00</td>
                        <td className="Right">£444.00</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="PriceSummary">
                  <div className="Total">
                    TOTAL PRICE:
                    <span>£444.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
      {/* )} */}
      {generalErrors.length > 0 && (
        <div className="InvoiceErrors">
          <div className="Img">
            {/* <img src={Icon_Error} alt="Error" /> */}
          </div>
          {generalErrors.map((e: string, key: number) => (
            <p key={key}>{e}</p>
          ))}
        </div>
      )}
    </>
  );
};

export default InvoicePage;
